<template>
    <div class="form-group row">
        <div class="col-sm-11">
            <toggle-button :value="val" @change="sendToParent" color="#232850"
                           v-model="val"
            />
            <span style="margin-left: 5px; color:#232850;font-size: 15px;" v-if="val == true">{{name}}</span>
            <span style="margin-left: 5px; color:#878787;font-size: 15px;" v-else-if="name ==titles.hasValue">{{titles.dontHaveValue}}</span>
            <span style="margin-left: 5px; color:#878787;font-size: 15px;" v-else> Pas {{name}}</span>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {ToggleButton} from 'vue-js-toggle-button';
    import {titles} from '../../utils/general/titles';

    Vue.component('ToggleButton', ToggleButton);
    export default {
        name: 'CheckBox',
        props: {
            name: String,
            inputKey: String,
            validate: Boolean
        },
        data() {
            return {
                titles,
                val: this.validate ? this.validate : false
            };
        },
        methods: {
            sendToParent() {
                this.$emit('method', this.inputKey, this.val);
            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
